import type { getMedia } from "@trydig/storyblok";

export function parseFocusPoint(
  focusPoint: string | undefined,
  { width = 1, height = 1 } = {},
) {
  if (!focusPoint) return;

  const [x = 1, y = 1] = focusPoint.split(":").at(0)?.split("x") || [];

  return {
    x,
    y,
    xPercent: Math.round((Number(x) / width) * 100),
    yPercent: Math.round((Number(y) / height) * 100),
  };
}
export type FocusPoint = ReturnType<typeof parseFocusPoint>;

export type Media = ReturnType<typeof getMedia>;
